import lodash from "lodash";
import { TextStyleTransformer } from "../text-style-transformer.js";
import { createCustomStyles } from "./generators/custom-styles.js";
import { createPalette } from "./generators/palette.js";
import { createTypography } from "./generators/typography.js";
import { buildCssVarsObj } from "./theme-utils.js";
const buildThemeCssVars = (theme, documentStyle) => {
  const documentStyleTheme = TextStyleTransformer.fromDocumentStyle(documentStyle).toTheme();
  const mergedTheme = lodash.merge({}, theme, documentStyleTheme);
  const { palette, paletteConfig, typography, customStyles, nativeStyle } = mergedTheme;
  const { paletteVarsObject } = createPalette(palette, paletteConfig);
  const typographyVarsObject = createTypography(typography);
  const customsVarsObject = createCustomStyles({
    customStyles,
    nativeStyle
  });
  const breakoutVars = {
    "breakout-normal-padding-start": theme?.breakout?.normalPadding.start ?? "0",
    "breakout-normal-padding-end": theme?.breakout?.normalPadding.end ?? "0",
    "breakout-full-width-padding-start": theme?.breakout?.fullWidthPadding?.start ?? "0",
    "breakout-full-width-padding-end": theme?.breakout?.fullWidthPadding?.end ?? "0"
  };
  const varsObj = {
    ...paletteVarsObject,
    ...typographyVarsObject,
    ...customsVarsObject,
    ...breakoutVars
  };
  return buildCssVarsObj(varsObj);
};
const buildThemePortalCssVars = (theme) => {
  const { palette, paletteConfig, settingsStyles, customStyles = {} } = theme;
  const { paletteVarsObject } = createPalette(palette, {
    settingsActionColor: paletteConfig?.settingsActionColor
  });
  const customsVarsObject = createCustomStyles({
    customStyles: { staticToolbar: customStyles?.staticToolbar },
    settingsStyles
  });
  return buildCssVarsObj({
    settingsActionColor: paletteVarsObject.settingsActionColor,
    settingsActionColorTuple: paletteVarsObject.settingsActionColorTuple,
    ...customsVarsObject
  });
};
export {
  buildThemeCssVars,
  buildThemePortalCssVars
};
//# sourceMappingURL=build-theme-css-vars.js.map
